import type { RecommendationItem } from '@kimuno/api-sdk';

import { LOGOUT, type LogoutAction } from '../actions/auth.actionTypes';
import { AsyncActionStatus } from '../actions/common.actionTypes';
import {
	FETCH_DASHBOARD_RECOMMENDATIONS,
	type FetchDashboardRecommendationsAction,
} from '../actions/recommendations.actionTypes';

type RecommendationsActionTypes = FetchDashboardRecommendationsAction | LogoutAction;

export interface RecommendationsState {
	status: AsyncActionStatus;
	// Keeps the API position: tracking reports each item's rank, gaps included.
	items: RecommendationItem[];
	recommendationId: string | null;
	modelVersion: string | null;
}

const initialState: RecommendationsState = {
	status: AsyncActionStatus.INITIAL,
	items: [],
	recommendationId: null,
	modelVersion: null,
};

const recommendations = (
	// biome-ignore lint/style/useDefaultParameterLast: parameter order is a fixed contract (Redux reducer signature / existing call sites)
	state = initialState,
	action: RecommendationsActionTypes
): RecommendationsState => {
	switch (action.type) {
		case LOGOUT.SUCCESS:
			return initialState;

		case FETCH_DASHBOARD_RECOMMENDATIONS.START:
			return { ...state, status: AsyncActionStatus.LOADING };

		case FETCH_DASHBOARD_RECOMMENDATIONS.SUCCESS: {
			const { items, recommendationId, modelVersion } = action.result.recommendations;
			return {
				status: AsyncActionStatus.READY,
				items: [...items].sort((a, b) => a.position - b.position),
				recommendationId,
				modelVersion,
			};
		}

		case FETCH_DASHBOARD_RECOMMENDATIONS.ERROR:
			return { ...state, status: AsyncActionStatus.ERROR };
	}

	return state;
};

export default recommendations;
